// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__body {
  display: grid;
  grid-template-columns: 325px auto;
  margin-left: 12px;
}
.header {
  height: 180px !important;
  background-color: hwb(197 1% 75%);
  min-width: -moz-fit-content;
  min-width: fit-content;
  max-width: auto;
  border-radius: 4px;
  margin: 0 32px !important;
  margin-top: 1rem !important;
}
.header .adjust {
  padding: 24px 0;
  text-align: center;
}
.header h1 {
  /* color: #0fc6ee; */
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  letter-spacing: 0.0075em;
}
.exicutepage {
  border: 4px black solid;
  display: flex;
  flex-direction: column;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
 
  background-color: rgb(195, 210, 235);
  position: absolute;
  top: 25%;
  left: 25%;
  z-index: 6;
}
.exicutepage .leftright {
  display: flex;
  flex-direction: row;
}
.exicutepage .leftright .left {
  display: flex;
  flex-direction: column;
  margin-left: 26px;
}
.exicutepage .leftright .left .Dropdown {
  margin: 0 auto;
  height: 28px;
  min-width: 217px;
  border: none;
  margin-bottom: 2px;
}
.exicutepage .leftright .right {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-left: 26px;
}
.page {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}
.geturl {
  border: 4px black solid;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width:max-content;
  height: auto;
  background-color: rgb(195, 210, 235);
  position: absolute;
  top: 35%;
  left: 1%;
  padding: 10px;
  z-index: 6;
}
.Dropdown {
  margin: 0 auto;
  height: 24px;
  min-width: 170px;
  width: -moz-fit-content;
  width: fit-content;
  border: none;
  margin-bottom: 2px;
}
.searchbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  padding: 10px;
  background-color: whitesmoke;
  border-radius: 5px !important;
  min-width: 300px;
  width: 400px;
  margin-left: 35rem;
  max-height: 48px;
}
.searchbar svg {
  font-size: 20px;
  /* padding: 10px 10px; */
}

.searchbar input {
  border: 0;
  background-color: transparent;
  outline: 0;
  flex: 1 1;
  font-size: 15px;
}

.subhead {
  margin-left: 26px !important;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.onexicute {
  margin-top: 10px;
}
.exicutepage .head {
  height: 50px;
  /* background-color: hwb(197 1% 75%); */
  text-align: center;
  padding: 10px;
  margin: 10px;
  border-radius: 4px;
}

.exicutepage p {
  margin: 15px auto;
}
.exicutepage .switch {
  margin: 0px auto !important;
}
.executebuton {
  display: flex;
  width: 100px !important;
  margin-left: 10% !important;
  margin-top: 10px !important;
  margin: 0 auto !important;
  background-color: rgb(125, 200, 227) !important;
  color: black !important;
  border-radius: 10px !important;
}
.delete-suite {
  width: 33%;
  height: 16.87%;
  position: fixed;
  top: 45%;
  right: 35%;
  left: 35%;
  bottom: 45%;
  z-index: 999;
  border: 4px black solid;
  background-color: rgb(195, 210, 235) !important;
  color: black !important;
  font-weight: 800 !important;
  font-size: 20px !important;
}
.css-12o5h4v-MuiButtonBase-root-MuiButton-root {
    top: 41%;
    width: 20%;
    left: 35%;
}
.delete_button{
  margin-top: 10px;
  margin-left:115px;
}
.statusmessage{
      border: 4px black solid;
}
.mesg_heading{
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: -27px;
    font-size: 18px;
    /* background-color: hwb(197 1% 75%); */
    border: 12px;
    border-radius: 4px;
    /* width: 445px; */
    padding: 5px;
}
.msg_heading_text{
  /* color: rgb(15, 198, 238); */
    margin-left: -35px !important;
}
.css-rqb3oc-MuiStack-root {
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding-top: 16px !important;
    width: 91% !important;
    margin-left: 25px !important;
}
.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.4375em;
    letter-spacing: 0.00938em;
    color: rgba(0, 0, 0, 0.87);
    box-sizing: border-box;
    cursor: text;
    display: inline-flex;
    align-items: center;
    position: relative;
    border-radius: 4px !important;
    padding-right: 14px !important;
    width: 83% !important;
}
.schedular{
   /* height: 180px; */
  background-color: hwb(197 1% 75%);
  min-width: -moz-fit-content;
  min-width: fit-content;
  max-width: auto;
  border-radius: 4px !important; 
  text-align: center;
  margin: 0 32px !important;
  margin-top: 96px !important;
}
.schedular h1 {
  color: #0fc6ee;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500 !important;
  font-size: 1.25rem !important;
  line-height: 1.6 !important;
  letter-spacing: 0.0075em !important;
}
.execute_button{
  display: flex;
  justify-content: center;
  align-items: center;
}
.time{
  height: 35px !important;
}
/* .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root{
  height: 35px !important;
} */
.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root{
  height: 35px !important;
}
.move_module {
  width: 33%;
  height: -moz-fit-content;
  height: fit-content;
  position: fixed;
  top: 35%;
  right: 35%;
  left: 35%;
  bottom: 45%;
  z-index: 999;
  border: 4px black solid;
  background-color: rgb(195, 210, 235) !important;
  color: black !important;
  font-weight: 800 !important;
  font-size: 20px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/NewCreateCollection/NewCreateCollection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,2BAAsB;EAAtB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,uDAAuD;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAkB;EAAlB,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;;EAEnB,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,aAAa;EACb,UAAU;AACZ;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,+CAA+C;EAC/C,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,QAAQ;EACR,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,+CAA+C;EAC/C,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;IACI,QAAQ;IACR,UAAU;IACV,SAAS;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;MACM,uBAAuB;AAC7B;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,uCAAuC;IACvC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;AACA;EACE,8BAA8B;IAC5B,6BAA6B;AACjC;AACA;IAII,aAAa;IAGb,sBAAsB;IACtB,cAAc;IACd,4BAA4B;IAC5B,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,oDAAoD;IACpD,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IAEtB,YAAY;IAIZ,oBAAoB;IAIpB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;AACzB;AACA;GACG,mBAAmB;EACpB,iCAAiC;EACjC,2BAAsB;EAAtB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,uDAAuD;EACvD,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;;GAEG;AACH;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,+CAA+C;EAC/C,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;AAC5B","sourcesContent":[".app__body {\n  display: grid;\n  grid-template-columns: 325px auto;\n  margin-left: 12px;\n}\n.header {\n  height: 180px !important;\n  background-color: hwb(197 1% 75%);\n  min-width: fit-content;\n  max-width: auto;\n  border-radius: 4px;\n  margin: 0 32px !important;\n  margin-top: 1rem !important;\n}\n.header .adjust {\n  padding: 24px 0;\n  text-align: center;\n}\n.header h1 {\n  /* color: #0fc6ee; */\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 500;\n  font-size: 1.25rem;\n  line-height: 1.6;\n  letter-spacing: 0.0075em;\n}\n.exicutepage {\n  border: 4px black solid;\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n  height: fit-content;\n \n  background-color: rgb(195, 210, 235);\n  position: absolute;\n  top: 25%;\n  left: 25%;\n  z-index: 6;\n}\n.exicutepage .leftright {\n  display: flex;\n  flex-direction: row;\n}\n.exicutepage .leftright .left {\n  display: flex;\n  flex-direction: column;\n  margin-left: 26px;\n}\n.exicutepage .leftright .left .Dropdown {\n  margin: 0 auto;\n  height: 28px;\n  min-width: 217px;\n  border: none;\n  margin-bottom: 2px;\n}\n.exicutepage .leftright .right {\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n  margin-left: 26px;\n}\n.page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 15px;\n}\n.geturl {\n  border: 4px black solid;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width:max-content;\n  height: auto;\n  background-color: rgb(195, 210, 235);\n  position: absolute;\n  top: 35%;\n  left: 1%;\n  padding: 10px;\n  z-index: 6;\n}\n.Dropdown {\n  margin: 0 auto;\n  height: 24px;\n  min-width: 170px;\n  width: fit-content;\n  border: none;\n  margin-bottom: 2px;\n}\n.searchbar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: end;\n  padding: 10px;\n  background-color: whitesmoke;\n  border-radius: 5px !important;\n  min-width: 300px;\n  width: 400px;\n  margin-left: 35rem;\n  max-height: 48px;\n}\n.searchbar svg {\n  font-size: 20px;\n  /* padding: 10px 10px; */\n}\n\n.searchbar input {\n  border: 0;\n  background-color: transparent;\n  outline: 0;\n  flex: 1;\n  font-size: 15px;\n}\n\n.subhead {\n  margin-left: 26px !important;\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n}\n.onexicute {\n  margin-top: 10px;\n}\n.exicutepage .head {\n  height: 50px;\n  /* background-color: hwb(197 1% 75%); */\n  text-align: center;\n  padding: 10px;\n  margin: 10px;\n  border-radius: 4px;\n}\n\n.exicutepage p {\n  margin: 15px auto;\n}\n.exicutepage .switch {\n  margin: 0px auto !important;\n}\n.executebuton {\n  display: flex;\n  width: 100px !important;\n  margin-left: 10% !important;\n  margin-top: 10px !important;\n  margin: 0 auto !important;\n  background-color: rgb(125, 200, 227) !important;\n  color: black !important;\n  border-radius: 10px !important;\n}\n.delete-suite {\n  width: 33%;\n  height: 16.87%;\n  position: fixed;\n  top: 45%;\n  right: 35%;\n  left: 35%;\n  bottom: 45%;\n  z-index: 999;\n  border: 4px black solid;\n  background-color: rgb(195, 210, 235) !important;\n  color: black !important;\n  font-weight: 800 !important;\n  font-size: 20px !important;\n}\n.css-12o5h4v-MuiButtonBase-root-MuiButton-root {\n    top: 41%;\n    width: 20%;\n    left: 35%;\n}\n.delete_button{\n  margin-top: 10px;\n  margin-left:115px;\n}\n.statusmessage{\n      border: 4px black solid;\n}\n.mesg_heading{\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    margin-top: -27px;\n    font-size: 18px;\n    /* background-color: hwb(197 1% 75%); */\n    border: 12px;\n    border-radius: 4px;\n    /* width: 445px; */\n    padding: 5px;\n}\n.msg_heading_text{\n  /* color: rgb(15, 198, 238); */\n    margin-left: -35px !important;\n}\n.css-rqb3oc-MuiStack-root {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    overflow: auto;\n    padding-top: 16px !important;\n    width: 91% !important;\n    margin-left: 25px !important;\n}\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {\n    font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1.4375em;\n    letter-spacing: 0.00938em;\n    color: rgba(0, 0, 0, 0.87);\n    box-sizing: border-box;\n    position: relative;\n    cursor: text;\n    display: -webkit-inline-box;\n    display: -webkit-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    position: relative;\n    border-radius: 4px !important;\n    padding-right: 14px !important;\n    width: 83% !important;\n}\n.schedular{\n   /* height: 180px; */\n  background-color: hwb(197 1% 75%);\n  min-width: fit-content;\n  max-width: auto;\n  border-radius: 4px !important; \n  text-align: center;\n  margin: 0 32px !important;\n  margin-top: 96px !important;\n}\n.schedular h1 {\n  color: #0fc6ee;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 500 !important;\n  font-size: 1.25rem !important;\n  line-height: 1.6 !important;\n  letter-spacing: 0.0075em !important;\n}\n.execute_button{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.time{\n  height: 35px !important;\n}\n/* .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root{\n  height: 35px !important;\n} */\n.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root{\n  height: 35px !important;\n}\n.move_module {\n  width: 33%;\n  height: fit-content;\n  position: fixed;\n  top: 35%;\n  right: 35%;\n  left: 35%;\n  bottom: 45%;\n  z-index: 999;\n  border: 4px black solid;\n  background-color: rgb(195, 210, 235) !important;\n  color: black !important;\n  font-weight: 800 !important;\n  font-size: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
